import RiskProTextMap from '../riskPro/RiskProTextMap';
import type { FooterLink } from 'venn-components';

export interface IHelpCenterLinks {
  INTERCOM_HELP_ALL_HREF: string;
  FACTOR_EXPOSURE_HREF: string;
  FACTOR_CONTRIBUTION_TO_RISK_HREF: string;
  FACTOR_CONTRIBUTION_TO_RETURN_HREF: string;
  INTERCOM_HELP_HREF: string;
  METRIC_DEFINITIONS_HREF: string;
  FORECASTS_FAQ_HREF: string;
  DEMO_PORTFOLIO_FAQ_HREF: string;
  DEMO_PRIVATE_PORTFOLIO_FAQ_HREF: string;
  STUDIO_FAQ_HREF: string;
  BENCHMARK_FAQ_HREF: string;
  FORECAST_RETURN_DEF_HREF: string;
  EXCESS_RETURN_DEF_HREF: string;
  TRACKING_ERROR_DEF_HREF: string;
  INFORMATION_RATIO_DEF_HREF: string;
  MAX_UNDERPERFORMANCE_DEF_HREF: string;
  HISTORICAL_RISK_STATISTICS_HREF: string;
  PORTFOLIO_LAB_FAQ_HREF: string;
  ADVANCED_SEARCH_FAQ_HREF: string;
  HOLDINGS_FAQ_HREF: string;
  VENNCAST_FAQ_HREF: string;
  CURRENCY_CONVERSION_ARTICLE_HREF: string;
  REBALANCE_STRATEGY_ARTICLE_HREF: string;
  INVESTMENT_CORRELATION_TOOL_HREF: string;
  FACTOR_LENS_FAQ_HREF: string;
  CURRENCY_FAQ_HREF: string;
  PROXY_FAQ_HREF: string;
  DESMOOTHING_FAQ_HREF: string;
  INTERPOLATION_EXTRAPOLATION_FAQ_HREF: string;
  WORKSPACE_MANAGEMENT_ARTICLE_HREF: string;
  GROWTH_SIMULATOR_FAQ_HREF: string;
  SCENARIO_ANALYSIS_FAQ_HREF: string;
  SENSITIVITY_ANALYSIS_FAQ_HREF: string;
  NOTABLE_PERIODS_FAQ_HREF: string;
  FACTOR_PERIODS_SOURCES_HREF: string;
  CATEGORIES_FAQ_HREF: string;
  FACTOR_ALERTS_FAQ_HREF: string;
  HISTORICAL_DRAWDOWN_FAQ_HREF: string;
  ACCESSING_ANALYSES_FAQ_HREF: string;
  INVESTMENT_UPLOADER_FAQ_HREF: string;
  RETURNS_UPLOADER_FAQ_HREF: string;
  MASTER_PORTFOLIO_ARTICLE_HREF: string;
  ADDEPAR_HELP_HREF: string;
  COMMON_BENCHMARKS_HELP_HREF: string;
  PORTFOLIO_COMPARISON_HELP_HREF: string;
  PRIVATE_ASSET_LAB_HELP_HREF: string;
  PEER_GROUP_ANALYSIS_HELP_HREF: string;
  PRIVATE_ASSET_UPLOADER_FAQ_HREF: string;
  PRIVATE_ASSET_CASH_FLOW_HELP_HREF: string;
  PRIVATE_PERFORMANCE_HELP_HREF: string;
  PORTFOLIO_CONSTRUCTION_FAQ_HREF: string;
  STUDIO_REPORT_LAB_AIS_FAQ_HREF: string;
  MISSING_INVESTMENTS_FAQ_HREF: string;
  PUBLIC_PRIVATE_ASSET_GROWTH_HREF: string;
  MULTI_PORTFOLIO_UPLOADER_FAQ_HREF: string;
  ANALYSIS_PERIOD_HELP_HREF: string;
  HISTORICAL_PORTFOLIOS_HELP_HREF: string;
  DESMOOTHING_HELP_HREF: string;
  ADVISORY_FEES_HELP_HREF: string;
  TAX_RATE_HELP_HREF: string;
  REDISTRIBUTION_HELP_HREF: string;
  DISCLOSURE_AND_DISCLAIMER_HREF: string;
}

export interface IMarcomSiteLinks {
  FACTORS_HOLISTIC_URL: string;
  FACTORS_PARSIMONIOUS_URL: string;
  FACTORS_ORTHOGONAL_URL: string;
  FACTORS_ACTIONABLE_URL: string;
  VENNSIGHTS_URL: string;
  REVERSE_OPTIMIZATION_URL: string;
  RESIDUALIZATION_URL: string;
  DISCLAIMERS: string;
}

export interface ILegalDocs {
  COOKIE_POLICY: FooterLink;
  PRIVACY_POLICY_LINK: FooterLink;
  SUBSCRIBER_AGREEMENT_LINK: FooterLink;
  USER_AGREEMENT_LINK: FooterLink | undefined;
  SERVICE_TIERS_LINK: string | undefined;
}
export type TextThemeProvider = {
  AppTitle: string;
  /** Brand-qualified product name, required at the first mention within any content block. */
  appTitleFullName: string;
  companyName: string;
  VenncastName: string;
  vdparName: string;
  factorLensName: string;
  factorLensNameTitleCase: string;
  factorLensShortName: string;
  askAiName: string;
  brandProvidedLabel: string;
  downloadBackupCodesFileName: string;
  downloadComparisonFileName: string;
  downloadDocumentsZipFileName: string;
  HelpCenterUrl: string;
  MarcomSiteUrl: string;
  MarcomSiteLinks?: IMarcomSiteLinks | undefined;
  HelpCenterLinks: IHelpCenterLinks;
  legalDocuments: ILegalDocs;
  supportEmail: string;
  salesEmail: string;
  operatorNameWithDefinition: string;
  operatorShortName: string;
  copyrightEntity: string;
  trademarkText: string;
  conflictsDisclosurePrint: string;
  conflictsDisclosureScreen: string;
};

/** Every brand-specific string in the app, so that product naming is changed in one place. */
export const getTextThemeProvider = (): TextThemeProvider => RiskProTextMap;
